import React from 'react';
import { themes } from './theme';
import EventBus from '../utils/EventBus';

class ThemeProvider extends React.Component {
  constructor(props) {
    super(props);
    const saved = localStorage.getItem('pmw-click-frontend-theme') || 'dark';
    this.state = { themeName: saved };
    this.toggleTheme = this.toggleTheme.bind(this);
  }

  toggleTheme() {
    const next = this.state.themeName === 'dark' ? 'light' : 'dark';
    localStorage.setItem('pmw-click-frontend-theme', next);
    this.setState({ themeName: next });
    EventBus.emit('themeChange', next);
  }

  componentDidMount() {
    this.applyTheme(this.state.themeName);
  }

  componentDidUpdate(_, prevState) {
    if (prevState.themeName !== this.state.themeName) {
      this.applyTheme(this.state.themeName);
    }
  }

  applyTheme(name) {
    const t = themes[name];
    const root = document.documentElement;
    root.setAttribute('data-theme', name);
    Object.entries(t.colors).forEach(([k, v]) => {
      root.style.setProperty('--' + k, v);
    });
  }

  render() {
    const { themeName } = this.state;
    return React.cloneElement(this.props.children, {
      theme:       themes[themeName],
      themeName,
      toggleTheme: this.toggleTheme,
    });
  }
}

export default ThemeProvider;
